import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TransitionFade',
  props: {
	duration: {
		type: String,
		default: '0.5s',
	},
	easing: {
		type: String,
		default: 'linear',
	},
	mode: String,
},
  setup(__props) {

_useCssVars((_vm, _setup) => ({
  "2b57f0b6": (_vm.duration),
  "390f477c": (_vm.easing)
}))



return { __sfc: true, }
}

})